import { gql } from "@apollo/client";

export const GET_INDICACION_APROBACION_RESPUESTAS = gql`
  query getIndicacionAprobacionRespuestas($idIndicacionAprobacion: Int!) {
    indicacionAprobacionRespuestas(idIndicacionAprobacion: $idIndicacionAprobacion) {
      success
      error
      valorEsperado {
        idIndicacionAprobacion
        idEstadoMedico
        estadoMedico
        fechaMedico
        observacionMedico
        idUsuarioMedico
        usuarioMedico            
        idEstadoComercial
        estadoComercial
        fechaComercial
        observacionComercial
        idUsuarioComercial
        usuarioComercial
      }
    }
  }
`;